import { appconfig } from 'src/config'

export type ServerErrorResponse = {
  errorMessage?: string
  errorDetails?: string
  errorSource?: string
}

const ISI_ERROR_SOURCE = 'ISI'

export const isIsiError = (data?: ServerErrorResponse) => data?.errorSource === ISI_ERROR_SOURCE

export const appendErrorSource = (message: string, data?: ServerErrorResponse) =>
  appconfig.SHOW_ERROR_SOURCE && isIsiError(data) ? `${message} (${ISI_ERROR_SOURCE})` : message
